module.exports = __webpack_public_path__ + "static/media/sicpa.2733725f.svg";